import React from 'react';
import { INDUSTRY_PORTFOLIO } from '../data/mock';
import { Reveal, AnimatedDivider } from './effects';

/* Anonymous, sector-based industry portfolio strip.
   B2B competitive sensitivity — we never publish client names. */
const ReferencesMarquee = () => {
  const items = [...INDUSTRY_PORTFOLIO, ...INDUSTRY_PORTFOLIO];

  return (
    <section className="relative py-24 lg:py-32 bg-[#F5F3EF] overflow-hidden border-y border-[#1A1A1A]/[0.06]">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 lg:mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-7">
              <AnimatedDivider width="3rem" />
              <Reveal delay={100} y={8} duration={700}>
                <span className="text-[10.5px] tracking-[0.34em] uppercase text-[#9A7F4F] font-medium">
                  Sektörel Portföy
                </span>
              </Reveal>
            </div>
            <Reveal delay={150}>
              <h2
                className="font-display text-[36px] lg:text-[54px] text-[#1A1A1A] leading-[1.06] tracking-[-0.02em]"
                style={{ fontWeight: 500 }}
              >
                10 farklı sektör.{' '}
                <span className="italic font-light text-[#9A7F4F]">Tek operasyonel disiplin</span>.
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:pb-3">
            <Reveal delay={350}>
              <p className="text-[14.5px] lg:text-[15.5px] text-[#1A1A1A]/68 leading-[1.7]">
                Müşteri gizliliği bir ilkemizdir — kurumsal müşterilerimizin isimlerini sayfalarımızda yayınlamayız.
                Aşağıda, hizmet verdiğimiz sektörlerin operasyonel ölçeğini paylaşıyoruz.
              </p>
            </Reveal>
          </div>
        </div>
      </div>

      {/* Anonymous sector ticker */}
      <div className="marquee-mask overflow-hidden">
        <div className="flex w-max animate-marquee">
          {items.map((r, i) => (
            <div
              key={i}
              className="min-w-[320px] lg:min-w-[380px] py-7 px-10 flex items-center gap-7 border-r border-[#1A1A1A]/[0.08]"
            >
              <span className="font-display numeric text-[42px] lg:text-[52px] text-[#9A7F4F]/35 leading-none font-medium">
                {String((i % INDUSTRY_PORTFOLIO.length) + 1).padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-[10.5px] tracking-[0.32em] uppercase text-[#9A7F4F] font-medium mb-2">
                  {r.sector}
                </div>
                <div className="font-display text-[18px] lg:text-[20px] text-[#1A1A1A] leading-tight tracking-[-0.005em] truncate">
                  {r.scale}
                </div>
                <div className="text-[11.5px] text-[#1A1A1A]/55 mt-1.5">
                  · {r.since}'den beri operasyonda
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReferencesMarquee;
